import type { BuilderElement } from '@builder.io/react'

export type BuilderProps = Partial<{ builderBlock: BuilderElement; builderState: never }>

/**
 * Remove props que são recebidas quando configurado com Builder.registerComponent
 * Todos os componentes Registrados no Buider recebem props que não devem ser repassadas para Tags HTML.
 * @param props any
 */
export function clearBuilderProps<T>(props: T & BuilderProps) {
  delete props.builderBlock
  delete props.builderState
}
